import React, { useEffect, useState } from "react";
import {
  FloatButton,
  Drawer,
  Select,
  DatePicker,
  Button,
  Skeleton,
  Result,
  Table,
} from "antd";
import RawGrid from "../../../../Elements/Grid/Grid";
import CustomDrawer from "../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../Elements/CustomSelect";

import TreeSelectCustom from "../../../../Elements/TreeSelect/TreeSelectCustom";
import ExportToExel from "../../../../Elements/Grid/Export";
import {
  generatedISOFormatDateString,
  roundOffValue,
  roundToTwoDecimalPlaces,
} from "../../../../../Utils/DateConverstion";
import { objectToQueryString } from "../../../../../Utils/CommonFunctions";
// import errorNew from "../../../../assets/error/error.png";
import TreeSelectCustomWithSelectAll from "../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
import { useStoreUpdaterWithAPI } from "../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../Common/APIConstants";
import { useSelector } from "react-redux";
// import { exportToExcel } from "./Export";


const ConsumptionReport = () => { 
  const {  makeRequest } = useStoreUpdaterWithAPI();

  const [sectionId, setSectionId] = useState(0);
  const [converterId, setConverterId] = useState(); 
  const [report, setReport] = useState([]);
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [fromDateObj, setFromDateObj] = useState(null);
  const [fromDateString, setFromDateString] = useState();
  const [toDateObj, setToDateObj] = useState(null);
  const [toDateString, setToDateString] = useState();
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false);
  const [chartSkip, setChartSkip] = useState();
  const [chartConverterInput, setChartConverterInput] = useState();
  const [chartGroupInput, setChartGroupInput] = useState();
  const [submit, setSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [converterGroupId, setConverterGroupId] = useState();
  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 100,
    },
  });

  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] = useState([]);
  const [consumptionData, setConsumptionData] = useState([])

  useEffect(()=>{
    makeRequest({ 
        type: APIConstants.GET, 
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`
        //  url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS_WATER}`
      }).then((res) => {
        console.log(res)
        setflowSectionResData(res);
      });

    makeRequest({ 
        type: APIConstants.GET, 
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_FLOW_CONVERTER_DETAILS}`
        //  url: `${APIConstants.GET_CONVERTER_DETAILS_WATER}`
      }).then((res) => {
        console.log(res)
        setgetFlowConverterResData(res);
      });

    makeRequest({  
        type: APIConstants.GET, 
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_STEAM_FLOW_GROUP_DETAILS}`
          // url: `${APIConstants.GET_GROUP_DETAILS_WATER}`
      }).then((res) => {
        console.log(res)
        setflowGroupDetailsResData(res);
      });

   
  },[])


  useEffect(()=>{

    if(converterGroupId) {
      makeRequest({ 
        type: APIConstants.GET,  
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_FLOW_NS_CONVERTER_DETAILS}?ConverterID=${converterGroupId}` 
      }).then((res) => {
        console.log(res) 
        setnsGetFlowConverterResData(res);
      });
    }
   

    makeRequest({ 
        type: APIConstants.GET,  
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${converterGroupId}` 
      }).then((res) => {
        console.log(res)
        setgetFlowSteamGroupMeterResData(res);
      });
  },[converterGroupId])

  const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList =
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList =
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList =
    (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
  const getFlowSteamGroupMeterList =
    (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];



    const fetchData =(data)=>{
      console.log(data.ConverterID)
      if(sectionId === 1) {
        makeRequest({ 
          type: APIConstants.GET,         
          url: `${APIConstants.STEAM_CONVERTOR_CONSUMPTION_REPORT}?ConverterID=${data.ConverterID}&FromDate=${data.FromDate}&ToDate=${data.ToDate}` 
        }).then((res) => {
          console.log(res)
          setConsumptionData(res);
        });
      } else {
        makeRequest({ 
          type: APIConstants.GET,         
          url: `${APIConstants.STEAM_GROUP_CONSUMPTION_REPORT}?GroupID=${data.GroupID}&FromDate=${data.FromDate}&ToDate=${data.ToDate}` 
        }).then((res) => {
          // console.log(res)
          setConsumptionData(res);
        });
      }
      
    }

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false); 
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });
  };

  let formattedFromDate;
  let formattedToDate;

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const inputConverterData = {
    // SectionID: 1,
    ConverterID: 1,
    // MeterIds: "1",
    FromDate: "2023-09-21T07:15:00.000Z",
    ToDate: "2023-09-25T07:15:00.000Z",
  };
  const inputGroupData = {
    // SectionID: 1,
    GroupID: 1,
    // MeterIds: "1",
    FromDate: "2023-09-21T07:15:00.000Z",
    ToDate: "2023-09-25T07:15:00.000Z",
  };

  const handleChangeSection = (changedValues) => {
    setSectionId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    console.log(changedValues)
    setConverterId(changedValues);
 
   
    if (changedValues) {
      setConverterError("");
    }
  };

  const onChangeFromDate = (date, dateString) => {
    setFromDateString(dateString);
    setFromDateObj(date);
    if (dateString) {
      setFromDateError("");
    }
  };

  const onChangeToDate = (date, dateString) => {
    setToDateString(dateString);
    setToDateObj(date);
    if (dateString) {
      setToDateError("");
    }
  };

  // const handleMeterChange = (selectedValues) => {
  //   setSelectedMeterIds(selectedValues);
  //   if (selectedValues) {
  //     // setMeterError("");
  //   }
  // };

  const setChartInputConverterData = () => {
    const fromDateTimeStamp = fromDateString;

    const fromDate = new Date(fromDateString || new Date());
    const toDate = new Date(toDateString || new Date());

    const fromHours = fromDate.getUTCHours();
    const fromMinutes = fromDate.getUTCMinutes();
    const fromSeconds = fromDate.getUTCSeconds();

    const toHours = toDate.getUTCHours();
    const toMinutes = toDate.getUTCMinutes();
    const toSeconds = toDate.getUTCSeconds();

    // const [fromHours, fromMinutes, fromSeconds] = time?.split(":").map(Number);
    // const [toHours, toMinutes, toseconds] = toTimeSplit?.split(":").map(Number);

    // Set the UTC hours, minutes, and seconds
    fromDate.setUTCHours(fromHours);
    fromDate.setUTCMinutes(fromMinutes);
    fromDate.setUTCSeconds(fromSeconds);

    toDate.setUTCHours(toHours);
    toDate.setUTCMinutes(toMinutes);
    toDate.setUTCSeconds(toSeconds);

    formattedFromDate = generatedISOFormatDateString(fromDate);
    formattedToDate = generatedISOFormatDateString(toDate);

    const ids = selectedMeterIds?.map((id) => id).join(",");
    const inputData = {
      ConverterID: Number(converterId) || 1,
      FromDate: formattedFromDate || "2023-09-21 07:15:00.000",
      ToDate: formattedToDate || "2023-09-25 07:15:00.000",
    };
    // const queryString = inputData;
    console.log(inputData)
    // setChartConverterInput(queryString);
    fetchData(inputData)
  };

  const setChartInputGroupData = () => {
    // const [date, time] =  fromDateString?.split("T")
    // const [toDateSplit, toTimeSplit] =toDateString?.split("T")
    const fromDateTimeStamp = fromDateString;

    const fromDate = new Date(fromDateString || new Date());
    const toDate = new Date(toDateString || new Date());

    const fromHours = fromDate.getUTCHours();
    const fromMinutes = fromDate.getUTCMinutes();
    const fromSeconds = fromDate.getUTCSeconds();

    const toHours = toDate.getUTCHours();
    const toMinutes = toDate.getUTCMinutes();
    const toSeconds = toDate.getUTCSeconds();

    // const [fromHours, fromMinutes, fromSeconds] = time?.split(":").map(Number);
    // const [toHours, toMinutes, toseconds] = toTimeSplit?.split(":").map(Number);

    // Set the UTC hours, minutes, and seconds
    fromDate.setUTCHours(fromHours);
    fromDate.setUTCMinutes(fromMinutes);
    fromDate.setUTCSeconds(fromSeconds);

    toDate.setUTCHours(toHours);
    toDate.setUTCMinutes(toMinutes);
    toDate.setUTCSeconds(toSeconds);

    formattedFromDate = generatedISOFormatDateString(fromDate);
    formattedToDate = generatedISOFormatDateString(toDate);

    const ids = selectedMeterIds?.map((id) => id).join(",");
    const inputData = {
      GroupID: Number(converterId) || 1,
      FromDate: formattedFromDate || "2023-09-21 07:15:00.000",
      ToDate: formattedToDate || "2023-09-25 07:15:00.000",
    };
    // const queryString = inputData;
    // setChartGroupInput(queryString);
    fetchData(inputData)
  };

  //   useEffect(()=>{

  //       if(sectionId == 1) {
  //         setReport(steamConverterData)
  //         setLoading(false)
  //       }
  //       if(sectionId == 2) {
  //         setReport(steamGroupData)
  //         setLoading(false)
  //       }
  //     },[steamConverterDataList,steamGroupDataList])

  useEffect(() => {
    setChartSkip(false);
    if (sectionId == 1) {
      setChartInputConverterData();
    }

    if (sectionId == 2) {
      setChartInputGroupData();
    }
  }, [chartConverterInput, chartGroupInput, submit]);

  const validateInput = (value, label) => {
    const error = !value ? `Please select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
  
    const selectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterId, "Converter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateInput(fromDateString, "From Date");

    setSectionError(sectionError);
    setConverterError(converterError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);

    if (!sectionError && !converterError && !fromDateError && !toDateError) {
      onClose();
      // setSubmit(!submit);
      if (sectionId === 1) {
        // setChartConverterInput(); 
        setChartInputConverterData()
        // fetchData()
        setSubmit(!submit); // This might be causing continuous re-renders
      } else if (sectionId === 2) {
        // setChartGroupInput(); 
        setChartInputGroupData()
        // fetchData()
        setSubmit(!submit); // This might be causing continuous re-renders
      }
    }
  };
  let columns = [
    { title: "Meter ID", dataIndex: "meterid", fixed: "left", width: "200px" },
    {
      title: "Meter Name",
      dataIndex: "metername",
      fixed: "left",
      width: "200px",
    },
    {
      title: "PreviousDay",
      dataIndex: "closingKwhTotal",
      fixed: "left",
      width: "200px",
    },
    {
      title: "ToDay",
      dataIndex: "openingKwhTotal",
      fixed: "left",
      width: "200px",
    },
    {
      title: "Consumption",
      dataIndex: "consumption",
      fixed: "left",
      width: "200px",
    },
  ];
  const totalWidth = columns.reduce(
    (acc, column) => acc + parseInt(column.width || 0, 100),
    0
  );

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
 
  let locale = {
    emptyText: (
      <Result
        title="Loading.."
        className={` ${isdarkMode ? 'darkfont' : 'whitemode'}`}
       

      />
    )
  };
  
  return (
    <div className=" rounded-md w-auto">
      {/* {isSteamConverterDataDetailsLoading && isSteamGroupDataDetailsLoading && (
        <>
          <Skeleton active paragraph={{ rows: 20 }} className="mt-12 mx-3" />
        </>
      )}
      {loading && (
        <>
          <Skeleton active paragraph={{ rows: 20 }} className="mt-12 mx-3" />
        </>
      )} */}
      {/* <div className="flex justify-center">
        {isSteamConverterDataDetailsError && isSteamGroupDataDetailsError && 
        (
          <div className="flex flex-col">
            <img className="w-[150px] h-[80px] " src={errorNew} />
            <p className="text-sm text-red-500 text-center">Server error</p>
            <p className="text-center">Please reload the page</p>
          </div>
        )}
      </div> */}

      {/* { !loading && !isSteamConverterDataDetailsLoading && !isSteamGroupDataDetailsLoading &&  ( */}
      <div className={`m-2`}>
        <Table
         locale={locale}
          columns={columns}
          dataSource={consumptionData}
          onChange={handleTableChange}
          pagination={tableParams.pagination}
          scroll={{ x: totalWidth, y: "450px" }}
          className={` dark ${isdarkMode ? 'ant-table-expanded-row-fixed-background ant-empty-description ant-table-cell custom-table-dark custom-table-raw' : 'whitemode'} `}

        />
      </div>

      {/* )} */}
      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {/* {sectionError} */}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            nameKey={sectionId === 1 ? "sitename" : "groupName"}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {/* {converterError} */}
          </small>
         {/* <TreeSelectCustomWithSelectAll 
            label="Meters:"
            data={
              sectionId === 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
            }
            idKey={sectionId === 1 ? "meterid" : "meterID"}
            valueKey={sectionId === 1 ? "meterid" : "meterID"}
            nameKey={sectionId === 1 ? "metername" : "meterName"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>  */}
          {/* <TreeSelectCustom
            label="Parameters:"
            data={parameters}
            idKey="id"
            nameKey="name"
            valueKey="name"
            selectedValues={selectedValues}
            setSelectedValues={setSelectedValues}
            onSelect={handleTreeChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {paraError}
          </small> */}
          <div className="mt-2 flex">
            <label className="pr-3 w-32 text-left">From Date:</label>
            <DatePicker
              value={fromDateObj}
              onChange={onChangeFromDate}
              className={`   ${isdarkMode ? 'datebackground' : 'whitemode'} w-80 `}
              dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
              showTime={{ format: "HH:mm:ss" }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </div>
          <small className="text-red-500 font-bold ml-[150px]">
            {/* {fromDateError} */}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32 text-left">To Date:</label>
            <DatePicker
              value={toDateObj}
              onChange={onChangeToDate}
              className={`   ${isdarkMode ? 'datebackground' : 'whitemode'} w-80 `}
              dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
              showTime={{ format: "HH:mm:ss" }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </div>
          <small className="text-red-500 font-bold ml-[150px]">
            {/* {toDateError} */}
          </small>
        </div>
        <div className="flex justify-center mt-4">
          <Button
            className="blue-btn"
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button>
        </div>
      </CustomDrawer>
    </div>
  );
};

export default ConsumptionReport;


